import { get, post } from "../common/api-service";
import { IDealershipUIConfiguration } from "../modules/dealer/interfaces/IDealershipUIConfiguration";

const DCPCustomizationAPI = {
    async getDealershipUIConfigurations() {
        const url = `/customisation/get`;
        return await get(url);
    },

    async getDealershipCustomTabIcon(dealershipId: string) {
        const url = `/customisation/get-dealership-custom-tab-icon/${dealershipId}`;
        return await get(url);
    },

    async setDealershipUIConfigurations(
        dealershipUIConfigurations: IDealershipUIConfiguration
    ) {
        const url = `/customisation/update`;
        return await post(url, dealershipUIConfigurations);
    },

    async sendTestEmail(
        dealershipUIConfigurations: IDealershipUIConfiguration
    ) {
        const url = `/customisation/send-test-email`;
        return await post(url, dealershipUIConfigurations);
    },
};

export default DCPCustomizationAPI;
